import { Card, CardContent } from "@/components/ui/card";
import { Users, CheckCircle, Clock, DollarSign, AlertTriangle, TrendingUp, TrendingDown, BarChart3 } from "lucide-react";

interface StatsProps {
  total: number;
  active: number;
  trials: number;
  revenue: number;
  expiringSoon: number;
  suspended: number;
  monthlyRevenue: number;
  yearlyRevenue: number;
  perChildCount?: number;
  perChildRevenue?: number;
}

const SubscriptionStats = ({ total, active, trials, revenue, expiringSoon, suspended, monthlyRevenue, yearlyRevenue, perChildCount = 0, perChildRevenue = 0 }: StatsProps) => {
  const cards = [
    { label: "إجمالي الاشتراكات", value: total, icon: Users, iconBg: "bg-primary/10", iconColor: "text-primary" },
    { label: "اشتراكات نشطة", value: active, icon: CheckCircle, iconBg: "bg-green-500/10", iconColor: "text-green-600", subtitle: `${total ? Math.round((active / total) * 100) : 0}% من الإجمالي` },
    { label: "تجربة مجانية", value: trials, icon: Clock, iconBg: "bg-blue-500/10", iconColor: "text-blue-600" },
    { label: "إجمالي الإيرادات", value: `${revenue.toLocaleString()} ج.م`, icon: DollarSign, iconBg: "bg-primary/10", iconColor: "text-primary", subtitle: `شهري: ${monthlyRevenue.toLocaleString()} | سنوي: ${yearlyRevenue.toLocaleString()}` },
    { label: "اشتراك بالطفل", value: perChildCount, icon: Users, iconBg: "bg-purple-500/10", iconColor: "text-purple-600", subtitle: perChildRevenue > 0 ? `${perChildRevenue.toLocaleString()} ج.م` : undefined },
    { label: "معلقة", value: suspended, icon: TrendingDown, iconBg: "bg-orange-500/10", iconColor: "text-orange-600" },
    { label: "تنتهي قريباً (30 يوم)", value: expiringSoon, icon: AlertTriangle, iconBg: "bg-yellow-500/10", iconColor: "text-yellow-600", highlight: expiringSoon > 0 },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {cards.map((card, i) => {
        const Icon = card.icon;
        return (
          <Card key={i} className={card.highlight ? "border-yellow-400 dark:border-yellow-600" : ""}>
            <CardContent className="p-4 flex items-center gap-3">
              <div className={`p-2.5 rounded-xl ${card.iconBg}`}>
                <Icon className={`w-5 h-5 ${card.iconColor}`} />
              </div>
              <div className="min-w-0">
                <p className="text-xs text-muted-foreground truncate">{card.label}</p>
                <p className="text-xl font-bold">{card.value}</p>
                {card.subtitle && <p className="text-[10px] text-muted-foreground truncate">{card.subtitle}</p>}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default SubscriptionStats;
